define('views/content/cd_managers',['require','views/base/list_page_view','views/components/cd_manager/cd_managers','collections/cd_manager','text!templates/content/cd_managers.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var CDManagersView = require('views/components/cd_manager/cd_managers');
    var CDManagersCollection = require('collections/cd_manager');

    var temp = require("text!templates/content/cd_managers.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'cd-managers-page',
        titleKey: 'cd_managers',

        setCollection: function () {
            this.collection = new CDManagersCollection();
        },

        onRender: function() {
            this.ListContainer.show(new CDManagersView({
                collection: this.collection
            }));
        }

    });
});
